import Product from './product';
import Theme from './theme';
import Testimonial from './testimonial';

export default class Config {
	configs: { [key: string]: string }[] = [];
	currentEvent?: {
		startDate: Date;
		endDate: Date;
		name: string;
		title?: string;
		theme?: Theme;
		productList?: Product[];
		testimonials?: Testimonial[];
	};
}
